import { cropOwlItemName, cropOwlPageIndicator, filterColorInPlace, cropOwlTotalCount, detectOwlClearTypeVariant, OwlHsvRanges, parseOwlLayout, prepareOwlRow, } from 'maplestory-owl-screenshot';
function prepareFromLayout(source, layout) {
    const atlasVariant = detectOwlClearTypeVariant(source, layout);
    if (!atlasVariant)
        return { ok: false, reason: 'text-rendering-not-detected' };
    const rows = layout.rows.map((row) => prepareOwlRow(source, row));
    const itemNameImage = cropOwlItemName(source, layout);
    const totalCountImage = cropOwlTotalCount(source, layout);
    filterColorInPlace(itemNameImage, OwlHsvRanges.headerRedText);
    filterColorInPlace(totalCountImage, OwlHsvRanges.headerRedText);
    return {
        ok: true,
        prepared: {
            layout,
            atlasVariant,
            itemNameImage,
            totalCountImage,
            pageIndicatorImage: cropOwlPageIndicator(source, layout),
            rows,
        },
    };
}
/** Internal preparation result that preserves the fatal stage for the v1 facade. */
export function prepareOwlScreenshotDetailed(source, options = {}) {
    const layout = parseOwlLayout(source, options);
    return layout
        ? prepareFromLayout(source, layout)
        : { ok: false, reason: 'owl-window-not-found' };
}
/** Low-level helper retained by the validation and research entry points. */
export function prepareOwlScreenshot(source, options = {}) {
    const result = prepareOwlScreenshotDetailed(source, options);
    return result.ok ? result.prepared : null;
}
//# sourceMappingURL=prepare.js.map